import { render, staticRenderFns } from "./VirtualSensor.vue?vue&type=template&id=cd8893c2&"
import script from "./VirtualSensor.vue?vue&type=script&lang=js&"
export * from "./VirtualSensor.vue?vue&type=script&lang=js&"
import style0 from "./VirtualSensor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports